
import { defineComponent } from 'vue';
import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';
import { HistoryPosition } from '@/models/Blocks/history-position';
import PrzBlock from '@/components/Blocks/Block/Mobile.vue';
import PrzLoader from '@/components/Muffin/Loader.vue';
import { TemplateStruct } from "@/models/Blocks/Itens/Types/template-struct";

Vue.use(VueObserveVisibility);

export default defineComponent({
    components:{
        PrzBlock,
        PrzLoader
    },
    props: {
        structs: {
            type: Array<TemplateStruct>,
            default: () => new Array<TemplateStruct>()
        },
        manualLoad: { // ex: club
            type: Object | null, // ex: {kStrings: [], hasNextPage: true}
            default: null
        },
    },
    data(){
        return {
            showLoader: false,
        }
    },
    watch:{
        structs:{
            handler(values: Array<TemplateStruct>){
                let value:TemplateStruct|null = values.length > 0 ? values[values.length-1] : null;
                if(value && value.key){
                    let hp = HistoryPosition.getInstance(value.key);
                    if(hp.load()){
                        if(hp.pageNumber > values.length){
                            this.$emit('nextpage');
                            this.showLoader = true;
                        }else{
                            this.$nextTick(() => {
                                setTimeout(() => { 
                                    hp.scrollTo();
                                    this.showLoader = false;
                                }, 200);
                            });
                        }
                    }
                }
            }, immediate: true
        }
    },
    methods:{
        visibilityChanged(visibility: boolean){
            if(visibility){
                this.$emit('nextpage');
            }
        },
        itemClick(item: any){
            this.$emit('itemClick',item);
        },
    }
});
